var map = {
	"./bitazza.svg": 61160,
	"./bitfinex.svg": 73562,
	"./bithumb.svg": 65406,
	"./gate.svg": 6944,
	"./indodax.svg": 34294,
	"./kucoin.svg": 50130,
	"./mexc.svg": 26184,
	"./okx.svg": 12321,
	"./poloniex.svg": 80053,
	"./vcc.svg": 70803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80219;